import { render, staticRenderFns } from "./InspectorCard.vue?vue&type=template&id=1c9a57a6&scoped=true"
import script from "./InspectorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectorCard.vue?vue&type=style&index=0&id=1c9a57a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9a57a6",
  null
  
)

export default component.exports